import { FilterSectionType } from '../enum/FilterSectionType';

export const filterSectionsAdvanced = [FilterSectionType.Investors, FilterSectionType.SecurityType];
